module.exports = __webpack_public_path__ + "static/media/bm.012b04b7.svg";